import { IIncidentCreate } from "../domain/IIncidnetCreate";
import { useAppDispatch } from "hooks/hooks";
import {
  addNewIncident,
  setNewIncidentPopover,
} from "../incident.slice";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister
} from "react-hook-form";
import { incidentsService } from "../services/incidents.service";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";
import IncidentTypeSelect from "./IncidentTypeSelectCreate";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import EmployeeSelect from "Dashboard/scenes/Resources/components/EmployeeSelect";
import { IIncidentUpdate } from "../domain/IIncidentUpdate";
import classes from "../../../../components/Popover/popover.module.scss";
import classesInc from "../styles/popover.module.scss";
import { styles } from "../../../../components/Popover/popoverSelectStyle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { IOption } from "Dashboard/domain/IOption";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IIncidentUpdate>;
  register: UseFormRegister<IIncidentUpdate>;
  control: Control<IIncidentUpdate, any>;
  getValues: UseFormGetValues<IIncidentUpdate>;
  errors: Partial<FieldErrorsImpl<IIncidentUpdate>>;
  reset: () => void;
  incidentTypeValue: IOption | undefined;
  setIncidentTypeValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
}

const NewIncidentPopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setNewIncidentPopover({ isOpen: false }));
    reset();
    props.setIncidentTypeValue(undefined);
  };

  const {
    handleSubmit,
    register,
    control,
    getValues,
    errors,
    reset,
  } = props;

  const onSubmit = async (data: IIncidentUpdate) => {
    //TODO: remove update service call once create request is extended
    try {
      if (!data.amount) data.amount = 0;
      var createData: IIncidentCreate = {
        incidentTypeId: data.incidentTypeId,
        projectId: data.projectId,
        date: data.date,
      };
      var i = await incidentsService.createIncidentForWorkingEmployee(
        createData
      );
      var newIncident = {
        ...data,
        incidentId: i.incidentId,
      };
      var ni = await incidentsService.updateIncidentForWorkingEmployee(
        newIncident
      );
      dispatch(addNewIncident(ni));
      toast.success("Incident je uspešno dodat.");
      close();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`${classesInc.newIncidentPopover} ${classes.basicPopover}`}
    >
      <div className={`${classes.row}
            ${errors.incidentTypeId ? classes.itemError : ""}`}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>tip</label>
          <Controller
            name="incidentTypeId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <IncidentTypeSelect
                customStyles={styles.customStyleClassic}
                error={errors.incidentTypeId}
                onChange={onChange}
                value={props.incidentTypeValue}
                setValue={props.setIncidentTypeValue}
                preserveInput={true}
              />
            )}
          />
        </div>
      </div>

      <div className={`${classes.row}
            ${errors.projectId ? classes.itemError : ""}`}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>projekat</label>
          <Controller
            name="projectId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <ProjectSelect
                customStyles={styles.customStyleClassic}
                error={errors.projectId}
                onChange={onChange}
                value={getValues("projectId")}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>počinioc</label>
          <Controller
            name="perpetratorEmployeeId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <EmployeeSelect
                customStyles={styles.customStyleClassic}
                // error={errors.projectId}
                onChange={onChange}
                value={getValues("perpetratorEmployeeId")}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum</label>
          <div>
            <Controller
              control={control}
              name="date"
              defaultValue={undefined}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                  className={`${classes.itemBorder} ${classes.dateItem}
                    ${errors.date ? classes.itemError : ""}`}
                />
              )}
            />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>iznos</label>
          <input type="text" className={classes.itemBorder}
            {...register("amount", { required: false })} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>napomena</label>
          <textarea
            {...register("description")}
          ></textarea>
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewIncidentPopover;
